import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as e from 'express';
import { GeneratedcvService } from 'src/app/pages/profile/generatedcv/services/generatedcv.service';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.css'],
})
export class PersonalDataComponent {
  @Input() formGroup!: FormGroup;
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  showValidationAlert: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private generatedcvService: GeneratedcvService
  ) {}

  ngOnInit() {
    let formData: any = localStorage.getItem('cvFormData');
    formData = JSON.parse(formData);
  }

  ngAfterViewInit() {
    // Force validation update after view init
    setTimeout(() => {
      this.formGroup.updateValueAndValidity();
    }, 100);
  }

  onNext() {
    this.markRequiredFieldsAsTouched();

    if (this.isPersonalDataValid()) {
      this.showValidationAlert = false;
      this.next.emit();
    } else {
      this.showValidationAlert = true;
      this.scrollToFirstError();
    }
  }

  onPrevious() {
    let formData: any = localStorage.getItem('cvFormData');
    formData = JSON.parse(formData);
    if (formData.editMode && formData.editMode == true) {
      this.previous.emit();
    }
    this.previous.emit();
  }

  private markRequiredFieldsAsTouched() {
    const requiredFields = ['name', 'phone', 'email', 'country', 'title'];

    requiredFields.forEach((fieldName) => {
      const field = this.formGroup.get(fieldName);
      if (field) {
        field.markAsTouched();
        field.markAsDirty();
      }
    });

    // Force update
    this.formGroup.updateValueAndValidity();
  }

  private isPersonalDataValid(): boolean {
    const requiredFields = [
      'name',
      'phone',
      'email',
      'country',
      'title',
      'linkedIn',
    ];

    const allValid = requiredFields.every((fieldName) => {
      const field = this.formGroup.get(fieldName);
      const isValid = field && field.valid;

      return isValid;
    });

    return allValid;
  }

  private getFormErrors(): any {
    const errors: any = {};
    const requiredFields = [
      'name',
      'phone',
      'email',
      'country',
      'title',
      'linkedIn',
    ];

    requiredFields.forEach((fieldName) => {
      const field = this.formGroup.get(fieldName);
      if (field && field.errors) {
        errors[fieldName] = field.errors;
      }
    });

    return errors;
  }

  private scrollToFirstError() {
    setTimeout(() => {
      const firstErrorElement = document.querySelector(
        '.ng-invalid.ng-touched'
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        // Focus on the input if possible
        const input = firstErrorElement.querySelector('input');
        if (input) {
          input.focus();
        }
      }
    }, 100);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.formGroup.get(fieldName);
    return !!(field && field.invalid && field.touched);
  }

  getFieldError(fieldName: string): string | null {
    const field = this.formGroup.get(fieldName);
    if (field && field.errors && field.touched) {
      if (field.errors['required'])
        return `${this.getFieldLabel(fieldName)} is required`;
      if (field.errors['minlength']) {
        const minLength = field.errors['minlength'].requiredLength;
        return `${this.getFieldLabel(
          fieldName
        )} must be at least ${minLength} characters`;
      }
      if (field.errors['pattern'])
        return `Invalid ${this.getFieldLabel(fieldName)} format`;
    }
    return null;
  }

  private getFieldLabel(fieldName: string): string {
    const labels: { [key: string]: string } = {
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      country: 'Country',
      title: 'Job Title',
      city: 'City',
      linkedIn: 'LinkedIn',
      portfolio: 'Portfolio',
      summary: 'Summary',
    };
    return labels[fieldName] || fieldName;
  }
}
